import React, { useState, useEffect } from 'react';
import TelephoneInput from '../GlobalComponents/TelephoneInput/TelephoneInput.js';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import styles from './ProvidersPanel.module.css';


export default function TestedNumbers({testedNumbers, type}) {
    console.log('TestedNumbers', testedNumbers);
   // need an array of set functions so I can pass them to TelephoneInput
    const [phoneNumbers, setPhoneNumbers] = useState(testedNumbers)
    useEffect(() => {
        setPhoneNumbers(testedNumbers);
    }, [testedNumbers]);

    const setPhoneNumberAtIndex = (index) => (newPhoneNumber) => {
        const newPhoneNumbers = [...phoneNumbers];
        newPhoneNumbers[index].formattedPhoneNumber = newPhoneNumber;
        setPhoneNumbers(newPhoneNumbers);
    };
    console.log('phoneNumbers', phoneNumbers);
    return (
        <>
            {phoneNumbers.map((number, index) => (
                <div key={index} className={styles.testedNumber}>
                    <div className={styles.phoneNumber}> {number.formattedPhoneNumber ? <TelephoneInput phoneNumber={number.formattedPhoneNumber} readOnly={type!=='modal'} setPhoneNumber={setPhoneNumberAtIndex(index)}/> : ''} </div>
                    <div className={styles.unformattedPhoneNumber}>{number.unformattedPhoneNumber}</div>
                    <div className={styles.validWhatsapp}>{number.validWhatsapp ? <CheckCircleIcon style={{color: 'green'}}/> : <ErrorIcon style={{color: 'red'}}/>}</div>
                </div>
            ))}
        </>
    )
}
